import React from 'react';
import { Heading, Slide, Section, preloader } from 'spectacle-ppa';
import CompleteLevelButton from 'components/completeLevelButton';

import videoSlide from '../../baseSlides/videoSlide';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './finish.md';

const md = new MarkdownScript(markdownFile);

export function preloadFinish () {
  preloader([
    imgLevel1Complete
  ]);
}

function finishSection ({ regionData }) {
  return (
    <Section id="finish">

      {/* Song */}
      {videoSlide({
        id: 'song-repeat',
        notes: md.getSubSectionAsHtml('Song', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Song', 'YouTube', regionData),
        lowRes: md.getSectionMetadata('Song', 'LowRes', regionData)
      })}

      {/* Level complete */}
      <Slide
      id="level-completed"
      notes={'<h2>Assembly Level Finished</h2>'}
      bgColor="transparent"
      finish>
        <div className="level-complete">
          <div className="level-complete-content">
              <Heading size={2}>
                Assembly Complete
              </Heading>
              <CompleteLevelButton/>
          </div>
        </div>
      </Slide>

    </Section>
  );
}

export default finishSection;



// WEBPACK FOOTER //
// ./programs/epsHybridAssembly/sections/90_finish/finishSection.jsx